<template>
  <div class="w-pages overflow-visible">
    <div class="w-header" v-if="isPc()">
      <div class="w-header-content-wrapper">
        <div data-animation="default" data-collapse="medium" data-duration="400" data-easing="ease" data-easing2="ease" role="banner" class="w-navbar w-nav">
          <Header activeMenuIndex="0"></Header>
        </div>
      </div>
    </div>
    <div class="header" v-if="!isPc()">
      <div class="w-header-content-wrapper">
        <div data-animation="default" data-collapse="medium" data-duration="400" data-easing="ease" data-easing2="ease" role="banner" class="w-navbar w-nav">
          <userHeader></userHeader>
        </div>
      </div>
    </div>

    <section class="w-hero-section">
      <div class="w-hero-mian-box" style="margin-top: 10px;">
        <div class="w-layout-blockcontainer container w-container">
          <div class="w-hero-content-box">
            <div class="w-hero-header">
              <h2 data-w-id="ff53ca5b-5326-51ef-f859-1dc2b60bd2ef" style="opacity:1" class="w-hero-title">{{$t("lang.titleP1")}}</h2>
              <div class="w-hero-heading-box">
                <h1 data-w-id="dff6b27e-2147-e904-4174-1f755ecc733d" style="opacity:1" class="w-hero-title"> <span class="w-gradient-text w-capitalized-text">{{$t("lang.titleP2")}}</span> {{$t("lang.titleP3")}}</h1>
              </div>
              <div data-w-id="61d6dcff-ec2f-ada5-bdb9-8cc18338eae5" style="opacity:1" class="w-title-desc">
                <p class="w-hero-desc"><strong>{{$t("lang.realized")}}</strong></p>
              </div>
            </div>
            <div data-w-id="26a02e58-4d4c-524f-6f0a-ed9bd0d8b9b7" style="opacity:1" class="w-hero-button-box">
              <div class="w-button-main-box">
                <a href="https://buy.revolutionnft.com/" class="w-button-style w-inline-block">
                  <div class="w-button w-dark-button">
                    <div class="w-button-text w-text-white">Get started</div>
                    <div class="w-button-shadow"></div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="w-layout-blockcontainer w-container-fluid w-container">
          <div data-w-id="58ce04cc-a377-dfd2-a409-f33b00ecc2fe" class="w-hero-image-section">
            <div class="w-banner-image-box hero-image-1"><img src="@/assets/img/home/img-5.png" loading="lazy" alt="Image" class="w-banner-image-1"></div>
            <div class="w-banner-image-box hero-image-2"><img src="@/assets/img/home/img-1.png" loading="lazy" alt="Image" class="w-banner-image-1"></div>
<!--            <div class="banner-image-box hero-image-3"><img src="@/assets/img/home/img-2.png" loading="lazy" alt="Image" class="banner-image-1"></div>-->
            <div class="w-banner-image-box hero-image-4"><img src="@/assets/img/home/img-3.png" loading="lazy" alt="Image" class="w-banner-image-1"></div>
            <div class="w-banner-image-box hero-image-5"><img src="@/assets/img/home/img-4.png" loading="lazy" alt="Image" class="w-banner-image-1"></div>
<!--            <div class="banner-image-box hero-image-6"><img src="@/assets/img/home/img-6.png" loading="lazy" alt="Image" class="banner-image-1"></div>-->
            <div class="w-banner-image-box hero-image-7"><img src="@/assets/img/home/img-7.png" loading="lazy" alt="Image" class="w-banner-image-1"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="w-client-section">
      <div class="w-layout-blockcontainer w-container w-container">
        <div class="w-clients-header">
          <div class="w-clients-text">{{$t("lang.clientP1")}} <span class="w-gradient-text"> {{$t("lang.clientP2")}} </span> {{$t("lang.clientP3")}}<span class="w-gradient-text">Revo </span> {{$t("lang.clientP4")}}</div>
        </div>
<!--        <div class="clients-logo-box">-->
<!--          <div class="clients-image-box"><img src="@/assets/img/home/icon1.d635df50.svg" loading="lazy" width="40" alt=""></div>-->
<!--        </div>-->
        <div class="scroll_wrapper">
          <div class="w-clients-logo-box" >
            <div v-for="(icon, index) in iconList" :key="index" class="w-clients-image-box">
              <img :src="icon.src" loading="lazy" :width="icon.width" :height="icon.width"  :alt="icon.alt" :class="icon.class">
            </div>
          </div>
          <div class="w-clients-logo-box" aria-hidden="true" >
            <div v-for="(icon, index) in iconList" :key="index" class="w-clients-image-box">
              <img :src="icon.src" loading="lazy" :width="icon.width" :height="icon.width"  :alt="icon.alt" :class="icon.class">
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="w-serices-section">
      <div class="w-layout-blockcontainer w-container w-container">
        <div class="w-layout-grid w-services-grid">
          <div id="w-node-c33a3e4d-dce0-de75-bc1e-5b0306253782-ac3e9fea" class="w-services-section-wrapper">
            <div id="w-node-_7a166a5a-5727-daf5-f22d-78b8b41f1589-ac3e9fea" class="w-section-title">
              <h2 class="w-title">{{$t("lang.nextGen")}}<span class="w-gradient-text"> Revolution</span>.</h2>
            </div>
            <div class="w-services-box padding-20">
              <div class="w-dyn-list">
                <div role="list" class="w-services-list w-dyn-items">
                  <div role="listitem" class="w-services-item w-dyn-item">
                    <div class="w-services-item-box">
                      <div class="w-services-wrapper-box"><img src="@/assets/img/home/微信图片_20241212192556.png" loading="lazy" alt="">
                        <div class="w-services-content">
                          <h3 class="w-services-title">{{$t("lang.Popular")}}</h3>
                          <p class="w-paragraph">{{$t("lang.auctionModel")}}</p>
                        </div>
                      </div>
                    </div>
                    <a class="w-services-button w-inline-block" @click="$router.push({ name: 'tradingMarket' })">
                      <div>{{$t("lang.viewMore")}}</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="w-node-_696be7eb-393a-b6e2-1da5-abd73d00e02a-ac3e9fea" class="w-services-grid-1">
            <div id="w-node-ac42e4d7-a5f3-0593-49de-cc9d578628b6-ac3e9fea" class="w-services-box">
              <div class="w-dyn-list">
                <div role="list" class="w-services-list w-dyn-items">
                  <div role="listitem" class="w-services-item w-dyn-item">
                    <div class="w-services-item-box">
                      <div class="w-services-wrapper-box"><img src="@/assets/img/home/Published.60089ec5.png" loading="lazy" sizes="(max-width: 479px) 100vw, (max-width: 631px) 87vw, (max-width: 767px) 549px, (max-width: 991px) 43vw, 549px" srcset="@/assets/img/home/Published.60089ec5-p-500.png 500w, @/assets/img/home/Published.60089ec5.png 549w" alt="">
                        <div class="w-services-content">
                          <h3 class="w-services-title">{{$t("lang.genesis")}}</h3>
                          <p class="w-paragraph">{{$t("lang.genesisdesc")}}</p>
                        </div>
                      </div>
                    </div>
                    <a @click="handleCreate" class="w-services-button w-inline-block">
                      <div>{{$t("lang.create")}}</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div id="w-node-e1b7c2a6-da2d-58b8-d4ee-9b3aaaeced9e-ac3e9fea" class="w-services-box">
              <div class="w-services-wrapper w-dyn-list">
                <div role="list" class="w-services-list w-dyn-items">
                  <div role="listitem" class="w-services-item w-dyn-item">
                    <div class="w-services-item-box">
                      <div class="w-services-wrapper-box"><img src="@/assets/img/home/rvt_buynow.jpg" loading="lazy" sizes="(max-width: 479px) 100vw, (max-width: 767px) 91vw, (max-width: 991px) 43vw, (max-width: 1200px) 90vw, 1080px" srcset="@/assets/img/home/rvt_buynow.jpg 500w, @/assets/img/home/rvt_buynow.jpg 800w, @/assets/img/home/rvt_buynow.jpg 1080w" alt="">
                        <div class="w-services-content">
                          <h3 class="w-services-title">{{$t("lang.firstNFT")}}</h3>
                          <p class="w-paragraph">{{$t("lang.cooperation")}}</p>
                        </div>
                      </div>
                      <a href="https://etherscan.io/token/0x61e24Ce4efe61EB2efd6AC804445df65f8032955" class="w-services-button w-inline-block" >
                        <div>{{$t("lang.viewMore")}}</div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="w-node-_366ebd92-bd03-dc7d-719c-d3876fedbee4-ac3e9fea" class="w-services-grid-1">
            <div class="w-services-box">
              <div class="w-dyn-list">
                <div role="list" class="w-services-list w-dyn-items">
                  <div role="listitem" class="w-services-item w-dyn-item">
                    <div class="w-services-item-box">
                      <div class="w-services-wrapper-box"><img src="@/assets/img/home/backR.jpg" loading="lazy" alt="">
                        <div class="w-services-content">
                          <h3 class="w-services-title">{{$t("lang.gameNavigation")}}</h3>
                          <p class="w-paragraph">{{$t("lang.introduced")}}</p>
                        </div>
                      </div>
                    </div>
                    <a @click="$router.push({ name: 'pickMarket' })" class="w-services-button w-inline-block" >
                      <div>{{$t("lang.viewMore")}}</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-services-box">
              <div class="w-services-main-wrapper">
                <a data-w-id="56281e35-395e-1fc8-4181-48312e64a961" href="https://buy.revolutionnft.com/" class="w-services-link-block w-inline-block"><img src="@/assets/img/home/right-up-arrow.svg" loading="lazy" style="-webkit-transform:translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(null) rotateY(null) rotateZ(0deg) skew(0, 0);-moz-transform:translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(null) rotateY(null) rotateZ(0deg) skew(0, 0);-ms-transform:translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(null) rotateY(null) rotateZ(0deg) skew(0, 0);transform:translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(null) rotateY(null) rotateZ(0deg) skew(0, 0);transform-style:preserve-3d" alt="Icon" class="services-arrow-icon"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="w-footer">
      <div class="w-layout-blockcontainer w-container w-container">
        <div class="w-layout-grid w-footer-grid-2">
          <div id="w-node-_2e80b746-847e-bc7b-4fba-a851b2cccda6-b2cccd90" class="w-seconadary-footer-wapper">
            <div class="w-footer-widget">
              <div class="w-footer-thumbnail"><img src="@/assets/img/home/REVOLUTION__1_-removebg-preview.png" loading="lazy" width="208" sizes="(max-width: 479px) 87vw, 208px" alt="Icon" srcset="@/assets/img/home/REVOLUTION__1_-removebg-preview-p-500.png 500w, @/assets/img/home/REVOLUTION__1_-removebg-preview-p-800.png 800w, @/assets/img/home/REVOLUTION__1_-removebg-preview-p-1080.png 1080w, @/assets/img/home/REVOLUTION__1_-removebg-preview.png 1371w" class="footer-logo"></div>
            </div>
          </div>
          <div class="w-widget-link-block">
            <h3 class="w-widget-title">{{$t("lang.quicklink")}}</h3>
            <div class="w-footer-link-list">
              <a class="w-widget-link w--current" @click="$router.push({ name: 'home' })" style="cursor: pointer;">{{ $t("lang.home") }}</a>
              <a class="w-widget-link"@click="$router.push({ name: 'pickMarket' })" style="cursor: pointer;">{{ $t("lang.opting") }}</a>
              <a class="w-widget-link"@click="$router.push({ name: 'tradingMarket' })" style="cursor: pointer;">{{ $t("lang.market") }}</a>
              <a class="w-widget-link"@click="$router.push({ name: 'mine' })" style="cursor: pointer;">{{ $t("lang.mine") }}</a>
              <a href="https://revonft.gitbook.io/revonft" class="w-widget-link">{{ $t("lang.doc") }}</a>
            </div>
          </div>
          <div id="w-node-_2e80b746-847e-bc7b-4fba-a851b2cccdbf-b2cccd90" class="w-widget-link-block">
            <h3 class="w-widget-title">{{$t("lang.ecoLinks")}}</h3>
            <div class="w-footer-link-list">
              <a href="https://www.revonft.vip/" class="w-widget-link" style="cursor: pointer;">{{$t("lang.referralAirdrop")}}</a>
              <a href="https://revolutionnft.com/" class="w-widget-link" style="cursor: pointer;">{{$t("lang.officialWeb")}}</a>
              <a href="https://buy.revolutionnft.com/" class="w-widget-link" style="cursor: pointer;">{{$t("lang.promotionalPurchase")}}</a>
            </div>
          </div>
          <div id="w-node-_2e80b746-847e-bc7b-4fba-a851b2cccdd7-b2cccd90" class="w-footer-widget-info">
            <h3 class="w-widget-title">Contact us</h3>
            <a href="mailto:info@revonft.vip" class="w-widget-mail">info@revonft.vip</a>
            <div class="w-footer-social-block">
              <a href="https://x.com/NFTRevo" class="w-footer-link-box w-inline-block"><img src="@/assets/img/home/twitter-icon.svg" loading="lazy" alt="Icon" class="footer-social-icon"></a>
              <a href="https://https://t.me/revolutionNFT" class="w-footer-link-box w-inline-block"><img src="@/assets/img/telegram.svg" loading="lazy" alt="Icon" class="footer-social-icon" style="scale: 0.6""></a>
              <a href="https://etherscan.io/token/0x61e24Ce4efe61EB2efd6AC804445df65f8032955" class="w-footer-link-box w-inline-block"><img src="@/assets/img/icon.png" loading="lazy" alt="Icon" class="footer-social-icon" style="filter: grayscale(100%); scale: 0.8"></a>
              <a href="https://app.uniswap.org/swap?inputCurrency=ETH&outputCurrency=0x61e24Ce4efe61EB2efd6AC804445df65f8032955" class="w-footer-link-box w-inline-block"><img src="@/assets/icon/icon21.svg" loading="lazy" alt="Icon" class="footer-social-icon" style="filter: grayscale(100%); scale: 0.8""></a>
            </div>
          </div>
        </div>
        <div class="w-copyright-footer">
          <div class="w-copyright-text"><strong>© Copyright 2025 Revolution,All rights Reserved<br></strong></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import {Whitepaper} from "@/config.js"
import Header from "@/components/header.vue";
import Banner from "@/components/banner-img.vue";
import Footer from "@/components/footer.vue";
import {isPc} from "@/utils/common";
import userHeader from "@/components/mobile/userHeader.vue";


export default {
  components: {
    userHeader,
    Header,
  },
  created() {
    this.lang = sessionStorage.getItem("Language");
    //load css
    // this.style = document.createElement('link');
    // this.style.rel = 'stylesheet';
    // this.style.type = 'text/css';
    // this.style.href = require("../../assets/style/home/normalize.css");
    // document.head.appendChild(this.style);
    //
    // this.style = document.createElement('link');
    // this.style.rel = 'stylesheet';
    // this.style.type = 'text/css';
    // this.style.href = require("../../assets/style/home/webflow.css");
    // document.head.appendChild(this.style);
    //
    // this.style = document.createElement('link');
    // this.style.rel = 'stylesheet';
    // this.style.type = 'text/css';
    // this.style.href = require("../../assets/style/home/rtv_wf.css");
    // document.head.appendChild(this.style);


  },
  data() {
    return {
      iconList: [
        { src: require("@/assets/img/home/icon7.0b753a42.svg"), width: 56, alt: "" },
        { src: require("@/assets/img/home/icon14.2216b1e1.svg"), width: 40, alt: "", class: "image-2" },
        { src: require("@/assets/img/home/icon10.9c01f68f.svg"), width: 40, alt: "" },
        { src: require("@/assets/img/home/icon13.856bf136.svg"), width: 40, alt: "" },
        { src: require("@/assets/img/home/icon12.ee543ae2.svg"), width: 40, alt: "" },
        { src: require("@/assets/img/home/icon16.a5795632.svg"), width: 40, alt: "" },
        { src: require("@/assets/img/home/icon9.7101992a.svg"), width: 40, alt: "" },
        { src: require("@/assets/img/home/icon18.487f92d5.svg"), width: 40, alt: "" },
        { src: require("@/assets/img/home/icon15.adc812d0.svg"), width: 40, alt: "" },
        { src: require("@/assets/img/home/icon19.8359bb40.svg"), width: 40, alt: "" },
        { src: require("@/assets/img/home/icon17.654ac317.svg"), width: 40, alt: "" },
        { src: require("@/assets/img/home/icon20.d6350d6a.svg"), width: 40, alt: "" },
        { src: require("@/assets/img/home/icon24.60187955.svg"), width: 40, alt: "" },
        { src: require("@/assets/img/home/icon21.92141227.svg"), width: 40, alt: "" },
        { src: require("@/assets/img/home/icon22.ceb7974e.svg"), width: 40, alt: "" },
        { src: require("@/assets/img/home/icon28.fe797247.svg"), width: 40, alt: "" },
        { src: require("@/assets/img/home/icon27.b1bd8628.svg"), width: 40, alt: "" },
        { src: require("@/assets/img/home/icon26.2fc01d17.svg"), width: 40, alt: "" },
        { src: require("@/assets/img/home/icon25.328b4bbe.svg"), width: 40, alt: "" },
        { src: require("@/assets/img/home/icon8.9616b084.svg"), width: 40, alt: "" },
        { src: require("@/assets/img/home/icon11.e7193c75.svg"), width: 40, alt: "" },
        { src: require("@/assets/img/home/icon23.5cf5b0eb.svg"), width: 40, alt: "" }
      ]
    };
  },
  methods: {
    isPc,
    Whitepaper() {
      return Whitepaper
    },
    handleCreate() {
      // let token = this.getStorageToken();
      // if (this.address == "") {
      //   this.$refs.showMetamask.show = true;
      // } else
      let token = window.localStorage.getItem("Token");
      if (!token) {
        // this.$router.push({ name: "homeIndex" });
        sessionStorage.setItem("iSsignature", false);
        this.getSign();
        this.$router.push({name:'login'});
        // this.$router.push({name:'login',query:{redirect:window.vm.$router.currentRoute.fullPath}});
      } else {
        this.$router.push({ name: "homeIndex" });
      }
    },
  }
}


</script>
<!--@import "../../assets/style/home/normalize.css";-->
<!--@import "../../assets/style/home/webflow.css";-->
<style scoped lang="css">

@import "../../assets/style/home/rtv_wf.css";
</style>

<style lang="less">

@keyframes scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(calc(-100% - var(--gap)));
  }
}

.scroll_wrapper{
  --gap: 20px;
  display: flex;
  overflow: hidden;
  user-select: none;
  gap: var(--gap);
  .w-clients-logo-box{
    flex-shrink: 0;
    display: flex;
    justify-content: space-around;
    gap: var(--gap);
    animation: scroll 25s linear infinite;
  }
}



.services-button{
  cursor: pointer;
}
</style>